import firebase from 'firebase/app'
import 'firebase/auth'
import config from '../config'

export const createFirebase = (name: string, session = true) => {
  const fi = firebase.initializeApp(config.firebase, name)

  if (session) {
    fi.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
  }
  return fi
}
export const initializeFirebase = () => {
  if (!firebase.apps.length) {
    return createFirebase('Default')
  }
  return firebase.apps[0]
}
